import { render } from "./HomeTemplate.vue?vue&type=template&id=462e22f4&scoped=true&ts=true"
import script from "./HomeTemplate.vue?vue&type=script&lang=ts"
export * from "./HomeTemplate.vue?vue&type=script&lang=ts"

import "./HomeTemplate.vue?vue&type=style&index=0&id=462e22f4&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/atomic-design/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-462e22f4"]])

export default __exports__